import { setCurrentView } from 'core/utils';
import { DispensingOrderReviewViewStore } from '../stores';
import React from 'react';
import { observer } from 'mobx-react';
import { DispensingOrderReviewTemplate } from 'themes/application/wound-order/pages';

@setCurrentView((rootStore) => new DispensingOrderReviewViewStore(rootStore), 'dispensingOrderReviewViewStore')
@observer
class DispensingOrderReviewPage extends React.Component {
    render(){
        return <DispensingOrderReviewTemplate {...this.props} />
    }
}

export default DispensingOrderReviewPage;